// Template278: Pekín - Dinero y pagos (DineroPagosPekin.jsx)
// Cabecera, intro, bloques (Efectivo, Alipay/WeChat, Tarjetas), caja amarilla resumen.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template278 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const bloque1Title = page?.texts?.[2]?.content;
	const bloque1Body = page?.texts?.[3]?.content;
	const bloque2Title = page?.texts?.[4]?.content;
	const bloque2Body = page?.texts?.[5]?.content;
	const bloque3Title = page?.texts?.[6]?.content;
	const bloque3Body = page?.texts?.[7]?.content;
	const tipResumen = page?.texts?.[8]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH4 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		fontWeight: 700,
		color: actualHeaderColor,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const bloques = [
		{ title: bloque1Title, body: bloque1Body, pink: false },
		{ title: bloque2Title, body: bloque2Body, pink: true },
		{ title: bloque3Title, body: bloque3Body, pink: false },
	];

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1.75 }}>
						{intro}
					</Box>
				)}

				{bloques.map((b, idx) =>
					b.title || b.body ? (
						<Box
							key={b.title}
							data-block-id={`text-${idx + 2}`}
							sx={{
								backgroundColor: b.pink ? "#fde1e0" : "#fff",
								border: b.pink ? "3px solid" : "2px solid #e8e8e8",
								borderColor: b.pink ? actualHeaderColor : "#e8e8e8",
								borderRadius: "12px",
								padding: "12px 14px",
								marginBottom: 1.75,
							}}
						>
							{b.title && (
								<Box component="h4" sx={{ ...estiloH4, marginBottom: 1 }}>
									{b.title}
								</Box>
							)}
							{b.body && (
								<Box
									component="p"
									sx={{ ...estiloP, fontSize: 13, lineHeight: 1.6 }}
								>
									{b.body}
								</Box>
							)}
						</Box>
					) : null,
				)}

				{tipResumen && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "10px 14px",
							fontSize: 13,
							color: "#444",
						}}
						dangerouslySetInnerHTML={{ __html: tipResumen }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template278.thumbnail = "/images/template-1.png";
export default Template278;
